export default class GATracker {
  constructor(options) {
    const {
      trackerId,
      ...opts
    } = options || {};
    this.trackerId = options.trackerId;
    this.options = opts;
  }
  init() {
    document.addEventListener('click', () => {
      if (window.gtag == null) {
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || pushEvent;
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${this.trackerId}&l=dataLayer&cx=c`;
        document.head.insertBefore(script, document.head.childNodes[0]);
      }
      if (this.trackerId) {
        window.gtag('js', new Date());
        window.gtag('config', this.trackerId, {
          send_page_view: false
        }); // For SPA
      }
    }, {
      once: true,
      capture: true
    });
  }
  pageView(location) {
    if (window.gtag && this.trackerId) {
      window.gtag('config', this.trackerId, {
        page_path: location.pathname
      });
    }
  }
  event(action, data) {
    if (window.gtag && this.trackerId) {
      window.gtag('event', action, data);
    }
  }
}
function pushEvent() {
  if (window.dataLayer) {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
}

// <!-- Global site tag (gtag.js) - Google Analytics -->
// <script async src="https://www.googletagmanager.com/gtag/js?id=G-XLWE87MLHT"></script>
// <script>
//   window.dataLayer = window.dataLayer || [];
//   function gtag(){dataLayer.push(arguments);}
//   window.gtagId = 'G-XLWE87MLHT'
//   // gtag('config', 'G-XLWE87MLHT');  
//   gtag('js', new Date());
//   gtag('config', 'G-XLWE87MLHT', { 'send_page_view': false });
// </script>